export default __webpack_public_path__ + "static/media/transactions.0d0c8e34.png";